var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.49 6.589a3.007 3.007 0 0 0-2.088-2.088C19.532 4 12.006 4 12.006 4S4.5 3.99 2.61 4.501A3.007 3.007 0 0 0 .522 6.589 31.247 31.247 0 0 0 0 12.394c-.006 1.94.17 3.876.522 5.783a3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088c.346-1.908.513-3.844.5-5.783a31.247 31.247 0 0 0-.5-5.805zM9.604 15.985V8.792l6.264 3.602-6.264 3.591z"
  }))));
};
export default SvgYoutube;